export const SaleOfferWmAssistantStatus = Object.freeze({
    RA: Symbol('RA'),
    SA: Symbol('SA'),
    PSC: Symbol('PSC'),
    FSC: Symbol('FSC'),
});

export function getStatusText(status) {
    return {
        [SaleOfferWmAssistantStatus.RA]: 'Wymaga pomocy asystenta',
        [SaleOfferWmAssistantStatus.SA]: 'Obsłużona przez asystenta',
        [SaleOfferWmAssistantStatus.PSC]: 'Częściowo obsłużona przez call center',
        [SaleOfferWmAssistantStatus.FSC]: 'Obsłużona przez call center',
    }[SaleOfferWmAssistantStatus[status]];
}